import { Card, Container } from '@mui/material';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import LinearProgressbar from 'src/components/common/LinearProgressbar';
import ProjectForm from 'src/forms/project/ProjectForm';
import useSettings from 'src/hooks/useSettings';
import { networkGetProjectInfo } from 'src/network/application';
import HeaderBreadcrumbs from '../../components/HeaderBreadcrumbs';
import Page from '../../components/Page';
import { PATH_DASHBOARD } from '../../routes/paths';

// ----------------------------------------------------------------------

export default function ProjectEdit() {
  const { projectId } = useParams();
  const { themeStretch } = useSettings();

  const [applicationDetails, setApplicationDetails] = useState();
  const [applicationDetailsLoading, setApplicationDetailsLoading] = useState();

  const fetchApplicationDetails = async () => {
    try {
      setApplicationDetailsLoading(true);
      const data = await networkGetProjectInfo(projectId);
      setApplicationDetails(data?.data?.items?.[0]);
    } catch (err) {
      console.error(err);
    } finally {
      setApplicationDetailsLoading(false);
    }
  };

  useEffect(() => {
    fetchApplicationDetails();
  }, []);

  if (applicationDetailsLoading) {
    return <LinearProgressbar />;
  }

  return (
    <Page title={'ویرایش محصول ' + applicationDetails?.ApplicationTitle}>
      <Container maxWidth={themeStretch ? false : 'lg'}>
        <HeaderBreadcrumbs
          heading={`ویرایش محصول ${applicationDetails?.ApplicationTitle}`}
          links={[
            { name: 'داشبورد', href: PATH_DASHBOARD.general.home },
            { name: 'فهرست محصولات', href: PATH_DASHBOARD.general.projects },
            { name: 'ویرایش محصول ' + applicationDetails?.ApplicationTitle },
          ]}
        />

        <Card sx={{ p: 6, zIndex: 0 }}>
          <ProjectForm applicationDetails={applicationDetails} />
        </Card>
      </Container>
    </Page>
  );
}
